require('./app');

require('./directives/addressEditor/AddressEditorDirective');
require('./directives/addressEditor/AddressEditorController');
require('./directives/buttonFilter/ButtonFilterDirective');
require('./directives/checkbox/CheckboxDirective');
require('./directives/clipboardBtn/ClipboardBtnDirective');
require('./directives/compile/CompileDirective');
require('./directives/collapsiblePanel/CollapsiblePanelDirective');
require('./directives/contactEditor/ContactEditorController');
require('./directives/contactEditor/ContactEditorDirective');
require('./directives/dateFilter/DateFilterDirective');
require('./directives/eAddressDisplay/EAddressDirective');
require('./directives/eAddressDisplay/EAddressDisplayDirective');
require('./directives/eAddressDisplay/EAddressIconDirective');
require('./directives/focusme/FocusMeDirective');
require('./directives/hasAddress/HasAddressDirective');
require('./directives/infoBlock/InfoBlockDirective');
require('./directives/isolatedForm/IsolatedFormDirective');
require('./directives/mask/CnaeMaskDirective');
require('./directives/mask/CnpjMaskDirective');
require('./directives/mask/IntegerMaskDirective');
require('./directives/mask/NireMaskDirective');
require('./directives/mask/NumericMaskDirective');
require('./directives/mask/PercentMaskDirective');
require('./directives/mask/RcpjMaskDirective');
require('./directives/mask/ReaisMaskDirective');
require('./directives/paginator/PaginatorController');
require('./directives/paginator/PaginatorDirective');
require('./directives/phoneDisplay/PhoneDisplayDirective');
require('./directives/radioTrackBy/RadioTrackByDirective');
require('./directives/table/TableDirective');
require('./directives/tablePanel/AvFilterManager');
require('./directives/tablePanel/TablePanelDirective');
require('./directives/textFilter/TextFilterDirective');
require('./directives/tooltip/TooltipDirective');
require('./directives/validation/passwordConfirm/PasswordConfirmDirective');
require('./directives/validation/uniqueValidation/UniqueValidationDirective');

require('./interceptors/DateInterceptor');

require('./filters/AddressFilter');
require('./filters/CnaeFilter');
require('./filters/CnpjFilter');
require('./filters/E164Filter');
require('./filters/IntegerFilter');
require('./filters/IsArrayFilter');
require('./filters/LeadingZerosFilter');
require('./filters/LocaleSensitiveOrderByFilter');
require('./filters/NireFilter');
require('./filters/PercentageFilter');
require('./filters/PhoneFilter');
require('./filters/ReaisFilter');
require('./filters/RelativeDateFilter');
require('./filters/ShortNameFilter');
require('./filters/StartFromFilter');

require('./services/AvService');
require('./services/integration/CnaeService');
require('./services/validation/UniqueValidationServiceProvider');

require('./util/StringUtil');

